import { render, staticRenderFns } from "./GroupRadio.vue?vue&type=template&id=d16e2b86&"
import script from "./GroupRadio.vue?vue&type=script&lang=js&"
export * from "./GroupRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports